import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { useInventoryShipFroms } from '../../../hooks/shipFrom';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_SHIP_FROM_ID } from '../../../constants';

import style from '../../style.module.less';
import { useShipFroms } from '../../../../../hooks/ship-froms/use-ship-froms';

const OrderNumberBulkUpdate = ({ shouldForceShipFrom = false }) => {
  const { bulkUpdateFulfillmentPlans } = useContext(MarkAsShippedContext);

  const shipFromsFromInv = useInventoryShipFroms();
  const shipFroms = useShipFroms();

  const shipFromsToUse = shouldForceShipFrom ? shipFroms : shipFromsFromInv;
  return (
    <DropdownMenu className={style['bulk-update-item']}>
      <DropdownMenuToggler>
        <FormattedMessage defaultMessage='Ship From' description='markAsShippedmodal.button.shipFrom' id='PFNFfZ' />
      </DropdownMenuToggler>
      {shipFromsToUse.map((shipFrom) => (
        <DropdownMenuItem
          key={shipFrom.shipFromId}
          onClick={() => bulkUpdateFulfillmentPlans(MARK_AS_SHIPPED_SHIP_FROM_ID, shipFrom.shipFromId)}
        >
          {shipFrom.name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

OrderNumberBulkUpdate.propTypes = {
  shouldForceShipFrom: PropTypes.bool,
};

export default OrderNumberBulkUpdate;
